import {
    faAngleDown,
    faArrowUp,
    faBed,
    faCaretDown,
    faCircle,
    faCircleCheck,
    faEllipsisVertical,
    faHouse,
    faSearch
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { BreadcrumbItem, Button, Col, Container, Dropdown, Form, Image, Row, Table } from "react-bootstrap";
import { Build_Img, Circle, Delete_2, Edit_2, Eye_2, Filters, } from "../../../../../assets/images";
import * as Constants from "../../../../Helper/constants/constants";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";
import PaginationComponent from "../../../CommanComponents/Pagination";


const ExistingPatient = () => {
    const breadcrumData = ['Dashboard', 'Existing Patient'];
    const breadcrumItem = ['Patient List']
    return (
        <div className="existing_patient">
            <WithoutImageHeader
                header={Constants.EXISTING_PATIENT}
                icon='notification'
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="existing_area">
                            <div className="title_btn_area">
                                <div className="left_area">
                                    <p>
                                        Patient List
                                    </p>
                                </div>
                                <div className="right_area">
                                    <a
                                        className="btn btn-primary"
                                        href="/add-Ward"
                                    >
                                        Add Patient
                                    </a>
                                </div>
                            </div>
                            <div className="search_section">
                                <div className="search_area">
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Control
                                                type="text"
                                                placeholder="Search"
                                            />
                                            <a>
                                                <div className="icon">
                                                    <FontAwesomeIcon
                                                        icon={faSearch}
                                                    />
                                                </div>
                                            </a>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="pagination_list">
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Select
                                                placeholder="10"
                                            >
                                                <option value={5}>5</option>
                                                <option value={10}>10</option>
                                                <option value={15}>15</option>
                                                <option value={20}>20</option>
                                                <option value={25}>25</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Form>
                                </div>

                                <div className="filter_button">
                                    <Button className="btn-primary btn-border" >
                                        <Image
                                            src={Filters}
                                            alt="..."
                                            className="image_area"
                                        />
                                        Filters
                                    </Button>
                                    <FontAwesomeIcon
                                        icon={faCircle}
                                        className="filter_icon"
                                    />
                                </div>
                            </div>
                            <div className="patient_list">
                                <div className="patient_data">
                                    <Table responsive>
                                        <tr>
                                            <th className="role_text">
                                                Patient Name
                                            </th>
                                            <th>Ward</th>
                                            <th>Room</th>
                                            <th>Bed</th>
                                            <th>Date of Discharge</th>
                                            <th>Action</th>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="profile_info">
                                                    <div className="left_area">
                                                        <div className="img_profile">
                                                            <Image
                                                                src={Build_Img}
                                                                alt="..."
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="right_area">
                                                        <h5>Robert William</h5>
                                                        <p>7DH5738H</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="label">
                                                    <p>Cardiology</p>
                                                </div>
                                            </td>
                                            <td>
                                                05
                                            </td>
                                            <td>
                                                05
                                            </td>
                                            <td>23/04/2022 (12:00 PM)</td>
                                            <td>
                                                <div className="icon">
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant="none"
                                                            id="dropdown-basic"
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faEllipsisVertical
                                                                }
                                                                className="ellipsis_icon"
                                                            />
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item>
                                                                Edit
                                                                <Image src={Edit_2} alt="..." className="image_area" />
                                                            </Dropdown.Item>
                                                            <Dropdown.Item>
                                                                Delete
                                                                <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="profile_info">
                                                    <div className="left_area">
                                                        <div className="img_profile">
                                                            <Image
                                                                src={Build_Img}
                                                                alt="..."
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="right_area">
                                                        <h5>Robert William</h5>
                                                        <p>7DH5738H</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="label">
                                                    <p>Cardiology</p>
                                                </div>
                                            </td>
                                            <td>
                                                05
                                            </td>
                                            <td>
                                                05
                                            </td>
                                            <td>23/04/2022 (12:00 PM)</td>
                                            <td>
                                                <div className="icon">
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant="none"
                                                            id="dropdown-basic"
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faEllipsisVertical
                                                                }
                                                                className="ellipsis_icon"
                                                            />
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item>
                                                                Edit
                                                                <Image src={Edit_2} alt="..." className="image_area" />
                                                            </Dropdown.Item>
                                                            <Dropdown.Item>
                                                                Delete
                                                                <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="profile_info">
                                                    <div className="left_area">
                                                        <div className="img_profile">
                                                            <Image
                                                                src={Build_Img}
                                                                alt="..."
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="right_area">
                                                        <h5>Robert William</h5>
                                                        <p>7DH5738H</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="label">
                                                    <p>Cardiology</p>
                                                </div>
                                            </td>
                                            <td>
                                                05
                                            </td>
                                            <td>
                                                05
                                            </td>
                                            <td>23/04/2022 (12:00 PM)</td>
                                            <td>
                                                <div className="icon">
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant="none"
                                                            id="dropdown-basic"
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faEllipsisVertical
                                                                }
                                                                className="ellipsis_icon"
                                                            />
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item>
                                                                Edit
                                                                <Image src={Edit_2} alt="..." className="image_area" />
                                                            </Dropdown.Item>
                                                            <Dropdown.Item>
                                                                Delete
                                                                <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="profile_info">
                                                    <div className="left_area">
                                                        <div className="img_profile">
                                                            <Image
                                                                src={Build_Img}
                                                                alt="..."
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="right_area">
                                                        <h5>Robert William</h5>
                                                        <p>7DH5738H</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="label">
                                                    <p>Cardiology</p>
                                                </div>
                                            </td>
                                            <td>
                                                05
                                            </td>
                                            <td>
                                                05
                                            </td>
                                            <td>23/04/2022 (12:00 PM)</td>
                                            <td>
                                                <div className="icon">
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant="none"
                                                            id="dropdown-basic"
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faEllipsisVertical
                                                                }
                                                                className="ellipsis_icon"
                                                            />
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item>
                                                                View
                                                                <Image src={Eye_2} alt="..." className="image_area" />
                                                            </Dropdown.Item>
                                                            <Dropdown.Item>
                                                                Edit
                                                                <Image src={Edit_2} alt="..." className="image_area" />
                                                            </Dropdown.Item>
                                                            <Dropdown.Item>
                                                                Delete
                                                                <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </td>
                                        </tr>
                                    </Table>
                                </div>
                            </div>
                            <div>
                                <PaginationComponent />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div >
    );
};

export default ExistingPatient;
